var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 8,
    fill: "#FFD9DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 21.3986C17.0004 19.7884 17.469 18.2123 18.3501 16.8579C19.2311 15.5034 20.4874 14.4278 21.9694 13.759C23.4514 13.0902 25.0967 12.8564 26.7093 13.0855C28.3219 13.3145 29.834 13.9968 31.0654 15.0511C32.2968 16.1054 33.1957 17.4872 33.6551 19.032C34.1145 20.5768 34.115 22.2196 33.6565 23.7647C33.1981 25.3098 32.3 26.6922 31.0692 27.7472C29.8384 28.8021 28.3268 29.4853 26.7143 29.7153V35.7999C26.7143 36.1182 26.5864 36.4234 26.3586 36.6485C26.1309 36.8736 25.822 37 25.5 37C25.178 37 24.8691 36.8736 24.6414 36.6485C24.4136 36.4234 24.2857 36.1182 24.2857 35.7999V29.7153C22.2624 29.4267 20.412 28.427 19.0739 26.8995C17.7358 25.372 16.9995 23.4191 17 21.3986ZM24.2129 20.1265C24.5541 19.7888 25.0171 19.5989 25.5 19.5984C25.822 19.5984 26.1309 19.472 26.3586 19.2469C26.5864 19.0219 26.7143 18.7166 26.7143 18.3983C26.7143 18.08 26.5864 17.7748 26.3586 17.5497C26.1309 17.3247 25.822 17.1982 25.5 17.1982C24.3728 17.1982 23.2918 17.6408 22.4948 18.4285C21.6978 19.2162 21.25 20.2846 21.25 21.3986C21.25 21.7169 21.3779 22.0221 21.6057 22.2472C21.8334 22.4723 22.1422 22.5987 22.4643 22.5987C22.7863 22.5987 23.0952 22.4723 23.3229 22.2472C23.5506 22.0221 23.6786 21.7169 23.6786 21.3986C23.6786 20.921 23.8704 20.4625 24.2129 20.1265Z",
    fill: "#FB7F7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLogo);
export default __webpack_public_path__ + "static/media/locationLogo.d8b626377c02c5edf04c26b97b624af1.svg";
export { ForwardRef as ReactComponent };